<template>
  <div class="bg-white">
    <AppHeader></AppHeader>
    <main class="xl:mx-auto xl:max-w-7xl xl:px-8">
      <Preloader v-if="isLoading" />
      <router-view />
    </main>
    <AppFooter></AppFooter>
  </div>
</template>

<script setup>
import { computed  } from 'vue';
import AppFooter from '@/components/AppFooter.vue';
import AppHeader from '@/components/AppHeader.vue';
import Preloader from './components/AppPreloader.vue';
import { useStore } from 'vuex';
const store = useStore();
const isLoading = computed(() => store.state.isLoading);
</script>